






import Vue from 'vue';
import ImageList from '../components/ImageList.vue';
export default Vue.extend({
  name: 'ImageManage',
  components: {
      ImageList
  }
});
